import type { CountryISO } from '@utilities/countries';

export const getFlagCharacter = (countryCode: CountryISO): string => {
  // Source: https://github.com/thekelvinliu/country-code-emoji/blob/master/src/index.js
  const offset = 127397;
  if (typeof countryCode !== 'string')
    throw new TypeError('argument must be a string');
  const cc = countryCode.toUpperCase();
  return /^[A-Z]{2}$/.test(cc)
    ? String.fromCodePoint(...[...cc].map((c) => c.charCodeAt(0) + offset))
    : '';
};
